$(document).ready(function() {
  // Wait for the page to fully load
  setTimeout(function() {
    // Product page adjustments
    if (window.location.pathname.indexOf('track-armour-ht6-auto-racing-shoes') > -1) {
      // Change the label text
      $('.product_form .select label').text('Choose your size');
      
      // Get the select element
      var sizeSelect = $('.product_form select');
      
      if (sizeSelect.length) {
        // Remove the placeholder option if it exists
        sizeSelect.find('option[value=""]').remove();
        
        // Modify the option text to only show the size number (no colon)
        sizeSelect.find('option').each(function() {
          var sizeText = $(this).text().trim();
          
          // Remove any text after ":" if it exists
          if (sizeText.indexOf(':') > -1) {
            sizeText = sizeText.split(':')[0].trim();
          }
          
          // Update the option text
          $(this).text(sizeText);
        });
      }
    }
    
    // Fix the cart page display
    if (window.location.pathname.indexOf('/cart') > -1) {
      // Process cart items
      $('.cart_content_info').each(function() {
        var cartItem = $(this);
        
        // Find the shoes product in the cart
        if (cartItem.find('.item_title a').text().indexOf('Racing Shoes') > -1) {
          // Look for the variant display
          cartItem.find('.variant-info').each(function() {
            var variantText = $(this).text().trim();
            
            // Check for pattern like "8:" or any number followed by colon
            if (/\d+:/.test(variantText)) {
              // Extract just the size number
              var sizeNumber = variantText.match(/(\d+\.?\d*)/)[0];
              
              // Replace with "Size: [number]"
              $(this).text("Size: " + sizeNumber);
            }
          });
        }
      });
    }
  }, 1000); // Longer wait for everything to initialize
});